import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { TR } from "@/lib/translations";
import { isEnglishSite } from "@/lib/siteMode";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const enSite = isEnglishSite();
  const [lang, setLangState] = useState(() => {
    if (enSite) return "en";
    try { return localStorage.getItem("th_lang") || "ua"; } catch { return "ua"; }
  });

  useEffect(() => {
    if (enSite) setLangState("en");
  }, [enSite]);

  useEffect(() => {
    document.documentElement.lang = lang === "en" ? "en" : "uk";
  }, [lang]);

  const setLang = useCallback((l) => {
    if (enSite) return;
    setLangState(l);
    try { localStorage.setItem("th_lang", l); } catch { /* ignore */ }
  }, [enSite]);

  const t = TR[lang] || TR.ua;
  return (
    <LangContext.Provider value={{ lang, setLang, t, enSite }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
